import API from "./api";
import { getSessionId } from "../utils/session";

// ======================
// ADD TO WISHLIST
// ======================
export const addToWishlist = async (productId) => {
  const res = await API.post(
    "/wishlist",
    { product_id: productId },
    {
      headers: {
        "x-session-id": getSessionId(),
      },
    }
  );

  return res.data;
};

// ======================
// GET WISHLIST
// ======================
export const getWishlist = async () => {
  const res = await API.get("/wishlist", {
    headers: {
      "x-session-id": getSessionId(),
    },
  });

  return res.data;
};

// ======================
// REMOVE FROM WISHLIST
// ======================
export const removeFromWishlist = async (productId) => {
  const res = await API.delete(`/wishlist/${productId}`, {
    headers: {
      "x-session-id": getSessionId(),
    },
  });

  return res.data;
};